import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import apiServices from "../../../services/api.services";


export const fetchShops = createAsyncThunk('shops/fetchShops', async () => {
    const response = await apiServices.shopList();
    return response.data;
})

export const shopsSlice = createSlice({
    name: 'shops',
    initialState: {
        isLoading: false,
        shops: [],
        error: null,
    },
    reducers: {
        addNewLead: (state, action) => {
            let {newLeadObj} = action.payload
            state.leads = [...state.leads, newLeadObj]
        },
        deleteLead: (state, action) => {
            let {index} = action.payload
            state.leads.splice(index, 1)
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchShops.pending, (state) => {
                state.isLoading = true
            })
            .addCase(fetchShops.fulfilled, (state, action) => {
                state.isLoading = false
                state.shops = action.payload
                state.error = null
            })
            .addCase(fetchShops.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
    },
})

export const {addNewLead, deleteLead} = shopsSlice.actions

export default shopsSlice.reducer